<template lang="pug">
  .component-client-action-buttons
    .dropdown-buttons
      EditInterventionRequestReveal(:request="item")
      DetailInterventionRequestReveal(:request="item")
      CompleteInterventionRequestReveal(:request="item")
      ActionButton(:action="remove", :confirm="true", color-class="warning" ) Delete
</template>
<script type="text/babel">
import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
import ActionButton from "../ActionButton";
import ModalReveal from "../../foundation/ModalReveal.vue";
import CreateInterventionRequestReveal from "../../../../pages/backoffice/CreateInterventionRequestReveal.vue";
import EditInterventionRequestReveal from "../../../../pages/backoffice/EditInterventionRequestReveal.vue";
import DetailInterventionRequestReveal from "../../../../pages/backoffice/DetailInterventionRequestReveal.vue";
import {EventBus} from "../../../../eventBus";
import CompleteInterventionRequestReveal from "../../../../pages/backoffice/CompleteInterventionRequestReveal.vue";

export default {
  name: "InterventionRequestButtons",
  components: {
    CompleteInterventionRequestReveal,
    DetailInterventionRequestReveal,
    EditInterventionRequestReveal, InterventionRequestReveal: CreateInterventionRequestReveal, ModalReveal, ActionButton
  },
  data() {
    return {
      entity: null
    }
  },
  created() {
  },
  methods: {
    remove: function () {
      return KeplerBackofficeSdk.maintenanceRequest.select(this.item).remove(() => {
        EventBus.$emit('reload-list')
      })
    },
  },
  props: ['item']
}
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// InterventionRequestButtons.vue?f6bb05e8